import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateNoteMutationVariables = Types.Exact<{
  input: Types.CreateNoteInput;
}>;


export type CreateNoteMutation = { createNote: { note: { id: string, rootBlockId?: string | null } } };


export const CreateNoteDocument = /*#__PURE__*/ gql`
    mutation createNote($input: CreateNoteInput!) {
  createNote(input: $input) {
    note {
      id
      rootBlockId
    }
  }
}
    `;

export function useCreateNoteMutation() {
  return Urql.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument);
};